import { ModalTools } from "@Utilities/ModalTools";
import { UnobtrusiveValidation } from "@Validation/UnobtrusiveValidation";

export class BaseSuggest
{
	constructor()
	{
		this.Initialize();
	}

	public Initialize(): void
	{
		const validation = new UnobtrusiveValidation();

		validation.Ajax.AjaxOnFailure = (xhr: XMLHttpRequest) =>
		{
			ModalTools.DisplayAlert("An error occurred while processing your request. Please try again.");
		};

		validation.Ajax.AjaxOnSuccess = (xhr: XMLHttpRequest) =>
		{
			const elmnt = document.getElementById("suggestion") as HTMLElement;
			elmnt?.scrollIntoView();
		};
	}
}